"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//

// const baseLength = 3
exports.default = {
  props: {
    minHeight: {
      type: Number,
      default: 100
    },
    repeat: {
      type: Number,
      default: 1
    }
  },
  computed: {
    itemHeight: function itemHeight() {
      //暂未实现计算高度
      return "15px";
    },
    list: function list() {
      var list = [[8, 16], [16, 8], [6, 8, 10]];
      var res = [];
      for (var i = 0; i < this.repeat; i++) {
        res.push.apply(res, list);
      }return res;
    }
  }
};